/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/credit_note_medium'
export default icon
